export const BIO_GAS_CONTRACT_VERSIONS = ["V33", "V34", "V93", "V94"];
